// extracted by mini-css-extract-plugin
module.exports = {"tab_selector":"burger-ingredients_tab_selector__3TUqW flex_row","scroll_container":"burger-ingredients_scroll_container__3h8YK scroll"};